import { render, staticRenderFns } from "./institutions.vue?vue&type=template&id=88586c9e&scoped=true&"
import script from "./institutions.vue?vue&type=script&lang=js&"
export * from "./institutions.vue?vue&type=script&lang=js&"
import style0 from "./institutions.vue?vue&type=style&index=0&id=88586c9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88586c9e",
  null
  
)

export default component.exports